import './Loading.css';

import React, { useEffect, useState, useCallback, useRef } from 'react';

export default function Loading(props) {
  const renderApp = () => {
    return (
      <>
        <div
          id="loadingBack"
          style={{
            visibility: props.loadingState ? 'visible' : 'hidden',
            opacity: props.loadingState ? 1 : 0,
          }}>
          <div className="profile-main-loader">
            <div className="loader">
              <svg className="circular-loader" viewBox="25 25 50 50">
                <circle
                  className="loader-path"
                  cx="50"
                  cy="50"
                  r="20"
                  fill="none"
                  stroke="#70c542"
                  strokeWidth="2"
                />
              </svg>
            </div>
          </div>
        </div>
      </>
    );
  };

  return renderApp();
}
